import { render } from "./NotFoundPage.vue?vue&type=template&id=e5e2c58a&ts=true"
import script from "./NotFoundPage.vue?vue&type=script&lang=ts"
export * from "./NotFoundPage.vue?vue&type=script&lang=ts"

import exportComponent from "/root/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__